
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { WTPPumpHouseExportTableDataAPI, WTPPumpHouseTableDataAPI } from '../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/PreventiveData/PumpHouseSlice'
import { Loading } from '../../../../../Helper/Loading'
import { WTPPreventivePumpHouseExportData } from './WTPPreventivePumpHouseExportPage'

export default function WTPPreventivePumpHousePage() {

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth  } = userDetails
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WaterSupplyDistributionNetworkPreventiveWorkPopupShow, setWaterSupplyDistributionNetworkPreventiveWorkPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)

    const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const handleClear = () => {
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setIsSearch(!isSearch)
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_MonthID: Month.ID,
            ReadingDate: Date,
            M_WardID: Ward.ID,
            M_ProjectID: 0,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleGetExport: handleGetExport
        }
        // if (WardName.ID !== 0) {
        dispatch(WTPPumpHouseTableDataAPI({ data }))
    }, [isSearch, IsClear, year.ID,Month.ID,Ward.ID])

    const { tableData, isLoading } = useSelector(state => state.WTPPumpHouseTableData)

    const handleGetExport = () => {
        const data = {
            M_FinancialYearID: year.ID,
            M_MonthID: Month.ID,
            ReadingDate: Date,
            M_WardID: Ward.ID,
            M_ProjectID: 0,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(WTPPumpHouseExportTableDataAPI({ data }))
    }
    const { ExporttableData, isExportLoading } = useSelector(state => state.WTPPumpHouseExportTableData)
    return (
        <div>
            {isLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content mb-5">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border mb-5">
                            <div className='mt-2'>
                                <h5>Pump House</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.length > 0 &&
                                            <WTPPreventivePumpHouseExportData
                                                ExcelData={ExporttableData}
                                                name='Pump House'
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-2 col-md-6">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id=""
                                                        value={Date}
                                                        onChange={(e) => (setDate(e.target.value))}
                                                    />
                                                </div>

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                />

                                            </div>

                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "center" }} rowSpan="2">Sr No.</th>
                                                        <th style={{ textAlign: "center" }} rowSpan="2">Time</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Voltage</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 1</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 2</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 3</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 4</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 5</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 6</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 7</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 8</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 9</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 10</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 11</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 12</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 13</th>
                                                        <th style={{ textAlign: "center" }} colspan="2">Pump 14</th>

                                                    </tr>
                                                    <tr>
                                                        {/* <td>Time</td> */}
                                                        <th >HT</th>
                                                        <th >LT</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                        <th >AMP</th>
                                                        <th >KWH</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.length > 0 ? tableData.map((i, j) => {
                                                            return (
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{j + 1}</td>
                                                                    <td>{i?.readingTime ? i?.readingTime : '-'}</td>
                                                                    <td>{i?.voltage_HT ? i?.voltage_HT : '-'}</td>
                                                                    <td>{i?.voltage_LT ? i?.voltage_LT : '-'}</td>
                                                                    <td>{i?.pump_AMP1 ? i?.pump_AMP1 : '-'}</td>
                                                                    <td>{i?.pump_KWH1 ? i?.pump_KWH1 : '-'}</td>
                                                                    <td>{i?.pump_AMP2 ? i?.pump_AMP2 : '-'}</td>
                                                                    <td>{i?.pump_KWH2 ? i?.pump_KWH2 : '-'}</td>
                                                                    <td>{i?.pump_AMP3 ? i?.pump_AMP3 : '-'}</td>
                                                                    <td>{i?.pump_KWH3 ? i?.pump_KWH3 : '-'}</td>
                                                                    <td>{i?.pump_AMP4 ? i?.pump_AMP4 : '-'}</td>
                                                                    <td>{i?.pump_KWH4 ? i?.pump_KWH4 : '-'}</td>
                                                                    <td>{i?.pump_AMP5 ? i?.pump_AMP5 : '-'}</td>
                                                                    <td>{i?.pump_KWH5 ? i?.pump_KWH5 : '-'}</td>
                                                                    <td>{i?.pump_AMP6 ? i?.pump_AMP6 : '-'}</td>
                                                                    <td>{i?.pump_KWH6 ? i?.pump_KWH6 : '-'}</td>
                                                                    <td>{i?.pump_AMP7 ? i?.pump_AMP7 : '-'}</td>
                                                                    <td>{i?.pump_KWH7 ? i?.pump_KWH7 : '-'}</td>
                                                                    <td>{i?.pump_AMP8 ? i?.pump_AMP8 : '-'}</td>
                                                                    <td>{i?.pump_KWH8 ? i?.pump_KWH8 : '-'}</td>
                                                                    <td>{i?.pump_AMP9 ? i?.pump_AMP9 : '-'}</td>
                                                                    <td>{i?.pump_KWH9 ? i?.pump_KWH9 : '-'}</td>
                                                                    <td>{i?.pump_AMP10 ? i?.pump_AMP10 : '-'}</td>
                                                                    <td>{i?.pump_KWH10 ? i?.pump_KWH10 : '-'}</td>
                                                                    <td>{i?.pump_AMP11 ? i?.pump_AMP11 : '-'}</td>
                                                                    <td>{i?.pump_KWH11 ? i?.pump_KWH11 : '-'}</td>
                                                                    <td>{i?.pump_AMP12 ? i?.pump_AMP12 : '-'}</td>
                                                                    <td>{i?.pump_KWH12 ? i?.pump_KWH12 : '-'}</td>
                                                                    <td>{i?.pump_AMP13 ? i?.pump_AMP13 : '-'}</td>
                                                                    <td>{i?.pump_KWH13 ? i?.pump_KWH13 : '-'}</td>
                                                                    <td>{i?.pump_AMP14 ? i?.pump_AMP14 : '-'}</td>
                                                                    <td>{i?.pump_KWH14 ? i?.pump_KWH14 : '-'}</td>
                                                                </tr>
                                                            )
                                                        })
                                                            :
                                                            <td colSpan={10}>No Data Found ...</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* {
                    WaterSupplyDistributionNetworkPreventiveWorkPopupShow ?
                        <WaterSupplyDistributionNetworkPreventiveWorkPopup
                            open={WaterSupplyDistributionNetworkPreventiveWorkPopupShow}
                            // popupHeading="Water Quality-Chlorine"                        
                            // handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                } */}
            </div>
        </div>



    )
}